var map = {
	"./about.svg": "a85b",
	"./activity.svg": "6736",
	"./add.svg": "c2a3",
	"./agreement.svg": "9467",
	"./arrow.svg": "b6e4",
	"./asset.svg": "b538",
	"./asset_s.svg": "92fd",
	"./auth.svg": "4e70",
	"./authAsset.svg": "3e09",
	"./auth_base.svg": "2366",
	"./bell.svg": "2fa4",
	"./bill.svg": "548c",
	"./c2c.svg": "34a7",
	"./cert.svg": "b1d4",
	"./chat.svg": "22b2",
	"./collect.svg": "a554",
	"./collect_s.svg": "b6f9",
	"./common.svg": "36ad",
	"./copy.svg": "19b6",
	"./dark.svg": "4123",
	"./date.svg": "235f",
	"./deposit.svg": "c44e",
	"./edit.svg": "aa46",
	"./empty.svg": "c091",
	"./exchanges.svg": "cf45",
	"./flashcash.svg": "563e",
	"./heel.svg": "e790",
	"./heel_s.svg": "2000",
	"./help.svg": "c932",
	"./history.svg": "c023",
	"./home.svg": "6bbe",
	"./home_s.svg": "7ca1",
	"./kline.svg": "aec1",
	"./lang.svg": "e9ae",
	"./light.svg": "7748",
	"./loan.svg": "2522",
	"./market.svg": "3338",
	"./market_s.svg": "78ab",
	"./mine.svg": "e8d1",
	"./move.svg": "2df4",
	"./my.svg": "4a07",
	"./my_s.svg": "3107",
	"./openAccount.svg": "c19d",
	"./out.svg": "a673",
	"./password.svg": "2a3d",
	"./position.svg": "15be",
	"./property.svg": "dde2",
	"./recharge.svg": "1b54",
	"./recharge_currency.svg": "a3d4",
	"./right.svg": "9a71",
	"./safe.svg": "bd01",
	"./search.svg": "8e8d",
	"./service.svg": "4e04",
	"./share.svg": "5306",
	"./simTrade.svg": "8779",
	"./team.svg": "64c9",
	"./theme.svg": "e534",
	"./top.svg": "deee",
	"./trade.svg": "07d5",
	"./trade_s.svg": "b841",
	"./transfer.svg": "e1d1",
	"./up.svg": "1380",
	"./user.svg": "b3b5",
	"./vip.svg": "1296",
	"./vip_fill.svg": "4fe3",
	"./with.svg": "07a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";